define('pages/main/products',["jquery", "appquery", "app", "modules/rackUtils"], function($, $$$, App, RackUtils) {
    var counter = 0;

    return {
        init : function(data) {
            var id = 'products-' + (counter++);
            this.prop('id', id)
            $$ = $$$(id);

            $$.self().addClass('full');
            var errorMessage = $$('.errorMessage');

            $$('.locate').click(function() {
                errorMessage.addClass('hidden');

                var product = $(this).closest('.product');
                var rack = App.utils.getId(product.data('rack'));
                var isle = product.data('isle');
                var rackInfo = RackUtils.check(rack);

                if(rackInfo.exists) {
                    if(rackInfo.existsOnCurrentFloor) {
                        App.page.render('map', {rack : rackInfo.value, isle : isle});
                    } else {
                        var otherFloor = rackInfo.existsOnFloors[0];
                        var floorNumber = otherFloor + App.utils.getNumberSuffix(otherFloor);
                        errorMessage.text('This product is available in ' + floorNumber + ' floor').removeClass('hidden');
                    }
                } else {
                    errorMessage.text("Sorry, We do not have information about this product's location.").removeClass('hidden').fadeOut(100).fadeIn(100);
                }
            });
        }
    };
});
